import {
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Drawer,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import AgGridTable from "../../../components/table/AgGridTable";
import { useEffect, useMemo, useRef, useState } from "react";
import { ColDef, GridOptions, ICellRendererParams } from "ag-grid-community";
import axiosInstance from "../../../axios/axios";
import { END_POINTS } from "../../../shared";
import { toast } from "react-toastify";
import moment from "moment";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import useRolePermissions from "../../../shared/hooks/useRolePermissions";
import { ROLES_CONTENT_PROPS } from "../../../shared/constants/constant-data";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useEncryptService } from "../../../shared/hooks";
import { set } from "lodash";
import React from "react";
import RescanWithCredentialPopup from "./RescanPopup";
import LoopIcon from "@mui/icons-material/Loop";
import MapCredentialPopup from "./MapCredentialPopup";
import bule_calender from "../../../assets/bule-calender.svg";
import green_calender from "../../../assets/green-calender.svg";
import cisco_assets from "../../../assets/cisco-assets.svg";
import Aws_img from "../../../assets/baseVersion/aws.svg";
import AWS_DARK from "../../../assets/baseVersion/AWS_DARK.svg"
import arista_assets from "../../../assets/arista-assets.svg";
import paloalto_assets from "../../../assets/paloalto-assets.svg";
import paloalto_dark from "../../../assets/paloalto-white.svg";
import cisco_dark from "../../../assets/cisco-white.svg";
import arista_dark from "../../../assets/arista-white.svg";
import juniperLogo from "../../../assets/juniper.svg";
import juniper_dark from "../../../assets/juniper-white.svg";
import green_shield from "../../../assets/green-shield.svg";
import red_shield from "../../../assets/red-shield.svg";
import orange_shield from "../../../assets/orange-shield.svg";
import misconfig from "../../../assets/misconfig.svg";
import cveBug from "../../../assets/cve-bug.svg";
import cveBugError from "../../../assets/cve-bug-error.svg";
import AssetDetailsDrawer from "../../../components/asset/AssetDetailsDrawer";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import xlsIcon from "../../../assets/xls.svg";
import downloadIcon from "../../../assets/downloadIcon.svg";
import downloadIcon_dark from "../../../assets/downloadIcon_dark.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { DarkMode, Padding } from "@mui/icons-material";
import { authActions } from "../../../store/authSlice";
import eventEmitter from "../../../components/utils/eventEmitter";

const CloudAssetDetails = () => {
  console.log("cloud Asset Details");
  const intervalRequest = React.useRef<NodeJS.Timeout | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [assetsRowData, setAssetsRowData] = useState<any[]>([]);
  const [assetsPreviousRowData, setAssetsPreviousRowData] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [anchorElAction, setAnchorElAction] = useState<null | HTMLElement>(
    null
  );
  const open = Boolean(anchorElAction);
  const [showDecommissioned, setShowDecommissioned] = useState(false);
  const [showDecomAssets, setShowDecomAssets] = useState(false);
  const { hasPermissions } = useRolePermissions();
  const [isReportDialogOpen, setIsReportDialogOpen] = useState(false);
  const [type, setType] = useState('asset_summary');
  const [reportFormat, setReportFormat] = useState("pdf");
  const [isDecommissionDialogOpen, setIsDecommissionDialogOpen] =
    useState(false);
  const [isCommissionDialogOpen, setIsCommissionDialogOpen] = useState(false);
  const [deviceIds, setDeviceIds] = useState<string[]>([]);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [openSidenav, setOpenSideNav] = React.useState(false);
  const [originalRegions, setOriginalRegions] = useState([]);
  const [currentRegions, setCurrentRegions] = useState<any>([]);
  const [selectedRegionId, setSelectedRegionId] = useState(null);
  const [expanded, setExpanded] = useState<Record<string, boolean>>({});
  const [isFirstPopupOpen, setIsFirstPopupOpen] = useState(false);
  const [isSecondPopupOpen, setIsSecondPopupOpen] = useState(false);
  const [isReportDrawerOpen, setIsReportDrawerOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("0");
  const [selectedscheduleOption, setScheduleSelectedOption] =
    useState("new_schedule");
  const [scheduleOptionsWeekly, setScheduleOptionsWeekly] = useState([]);
  const [scheduleOptionsFrequency, setScheduleOptionsFrequency] = useState([]);
  const [isallScheduleable, setIsAllScheduleable] = useState(false);
  const [scanSummaryData, setScanSummaryData] = useState([]);
  const [isCancelSchedulePopupOpen, setIsCancelSchedulePopupOpen] =
    useState(false);
  const [removeAllSchedules, setRemoveAllSchedules] = useState(false);
  const [assetsCredData, setAssetsCredData] = useState([]);
  const [assetCriticalityData, setAssetCriticalityData] = useState([]);
  const [assetCriticalityOptions, setAssetCriticalityOptions] = useState<any>(
    []
  );
  const [credTypes, setCredtypes] = useState([]);
  const [isRescanPopupOpen, setIsRescanPopupOpen] = useState(false);
  const [isMapCredentialPopupOpen, setIsMapCredentialPopupOpen] =
    useState(false);
  const [isAssetCriticalityDialogOpen, setIsAssetCriticalityDialogOpen] =
    useState(false);
  const [latestRescanDevicesList, setLatestRescanDevicesList] = useState<
    string[]
  >([]);
  const [rescanResponseData, setRescanResponseData] = useState<any>();
  const [assetDrawerOpen, setAssetDrawerOpen] = useState(false);
  const [selectedAssetSideNav, setSelectedAssetSideNav] = useState<any>(null);
  const [scheduledTableInfo, setScheduledTableInfo] = useState<any>(null);
  const [selectedCriticalId, setSelectAssetsCriticaledId] = useState<any>("");
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const { doEncryptLogin } = useEncryptService();
  const location = useLocation();
  let url = END_POINTS.DEVICE_LIST;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const gridApiRef = useRef<any>(null);
  const onGridReady = (params: any) => {
    gridApiRef.current = params.api;
  };
  let module = "";
  //const location = useLocation();
  console.log(location.pathname, "location.pathname");
  if (location.pathname == "/on-premises/assets") {
    module = "on_premise";
    url = END_POINTS.DEVICE_LIST;
  } else {
    url = END_POINTS.DEVICE_LIST_CLOUD;
    module = "cloud";
  }

  const ScheduledTable = ({ scheduledTableInfo, tableHeading }: any) => {
    return (
      <Box>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Schedule Information - {tableHeading}
        </Typography>

        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Scan Name</TableCell>
                <TableCell>Frequency</TableCell>
                <TableCell>Schedule</TableCell>
                <TableCell>Time</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {scheduledTableInfo.map(
                (
                  row: {
                    Scan_Name: string;
                    Frequency: string;
                    Schedule: string;
                    Time: string;
                  },
                  index: number
                ) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.Scan_Name}</TableCell>
                    <TableCell>{row.Frequency}</TableCell>
                    <TableCell>{row.Schedule}</TableCell>
                    <TableCell>{row.Time}</TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  const generateNISTColumns = (data: any[]) => {
    if (!data || data.length === 0) return [];
    const nistKeys = Object.keys(data[0]).filter((key) =>
      key.startsWith("NIST_")
    );
    return nistKeys.map((key, index) => ({
      field: key,
      headerName: key,
      filter: true,
      minWidth: 180,
      showNist: index === 0,
      cellRenderer: (params: any) => {
        if (params.data?.status !== 3) {
          return null;
        }
        const rawValue = Number(params.value) || 0;
        const value = Math.round(rawValue); // ✅ Round to nearest whole number

        const progressColor =
          value >= 75 ? "green" : value >= 50 ? "orange" : "red";

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              whiteSpace: "nowrap",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: 30,
                height: 30,
              }}
            >
              {/* Background circle */}
              <CircularProgress
                variant="determinate"
                value={100}
                size={30}
                thickness={5}
                sx={{ color: "#c5c5d2" }}
              />
              {/* Foreground progress */}
              <CircularProgress
                variant="determinate"
                value={value}
                size={30}
                thickness={5}
                sx={{
                  color: progressColor,
                  position: "absolute",
                  left: 0,
                  top: 0,
                }}
              />
            </Box>
            <Typography variant="body2" fontWeight={600}>
              {`${value}%`}
            </Typography>
          </Box>
        );
      },

      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    }));
  };
  const agGridInlineStyles = useMemo(
    () => ({
      padding: "0px",
      // "& .ag-body-vertical-scroll": {
      //   width: "0px !important",
      //   minWidth: "0px !important",
      // },
      // "& .ag-body-vertical-scroll-viewport": {
      //   width: "0px !important",
      //   minWidth: "0px !important",
      // },
      "& .ag-center-cols-clipper": {
        marginRight: 0,
      },
      "& .ag-center-cols-viewport": {
        marginRight: 0,
      },
    }),
    []
  );

  const nistColumns = generateNISTColumns(assetsRowData);

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    suppressMovable: false,
  };
  const gridOptions: GridOptions = {
    defaultColDef,
    rowHeight: 48,
    headerHeight: 48,
    suppressCellFocus: true,
    getRowStyle: (params: any) => {
      if (showDecommissioned) return { cursor: "default" };
      if (params.data && params.data.last_scan_status === false) return { cursor: "default" };
      return { cursor: "pointer" };
    },
    suppressRowClickSelection: true,
    rowMultiSelectWithClick: false,
    enableCellTextSelection: true,
    ensureDomOrder: true,
    rowSelection: "multiple" as const,
    onSelectionChanged: (event: any) => {
      const selectedNodes = event.api.getSelectedNodes();
      const selectedData = selectedNodes.map((node: any) => node.data);
      setSelectedRows(selectedData);
      console.log("Selected rows:", selectedData);
    },
  };
  const assetsColumnDefs: any = [
    {
      field: "selection",
      headerName: "",
      minWidth: 70,
      maxWidth: 80,
      checkboxSelection: true,
      headerCheckboxSelection: true,
      // pinned: "left",
      sortable: false,
      filter: false,
      resizable: false,
      suppressMovable: true,
      lockPosition: true,
      lockPinned: true,
      suppressSizeToFit: true,
    },
    {
      field: "number",
      headerName: "#",
      lockPosition: true,
      lockPinned: true,
      filter: false,
      minWidth: 80,
      width: 90,
    },
    {
      field: "cloud",
      headerName: "Resource Name",
      filter: true,
      minWidth: 180,
      width: 180,
      flex: null, // Completely disable flex for this column
      resizable: true,
      cellClass: 'ag-cell-resource-name',
      suppressSizeToFit: false,
      suppressAutoSize: false,
      cellRenderer: (params: ICellRendererParams) =>
        params.data.vendor.toLowerCase() === "cisco" ? (
          <div style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "100%",
            overflow: "hidden"
          }}>
            <img
              src={isDarkMode ? cisco_dark : cisco_assets}
              alt="Cisco"
              style={{ width: "60px", height: "20px" }}
            />
          </div>
        ) : params.data.vendor.toLowerCase() === "juniper" ? (
          <div style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "100%",
            overflow: "hidden"
          }}>
            <img
              src={isDarkMode ? juniper_dark : juniperLogo}
              alt="Juniper"
              style={{ width: "60px", height: "20px" }}
            />
          </div>
        ) : params.data.vendor?.toLowerCase() === "paloalto" || params.data.vendor?.toLowerCase() === "palo alto" ? (
          <div style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "100%",
            overflow: "hidden"
          }}>
            <img
              src={isDarkMode ? paloalto_dark : paloalto_assets}
              alt="Palo Alto"
              style={{ width: "60px", height: "20px" }}
            />
          </div>
        ) : params.data.vendor.toLowerCase() === "arista" ? (
          <div style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "100%",
            overflow: "hidden"
          }}>
            <img
              src={isDarkMode ? arista_dark : arista_assets}
              alt="Arista"
              style={{ width: "60px", height: "20px" }}
            />
          </div>
        ) : params.data.cloud.toLowerCase() === "amazon web services" ? (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            pr: 1
          }}>
            <img
              src={isDarkMode ? AWS_DARK : Aws_img}
              alt="AWS"
              style={{ width: "20px", height: "20px", flexShrink: 0 }}
            />
            <Tooltip
              title={params.data.resource_name}
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#fff",
                    color: "#000",
                    boxShadow: 1,
                    fontSize: "0.775rem",
                    cursor: "pointer",
                  },
                },
                arrow: {
                  sx: {
                    color: "#fff",
                  },
                },
              }}
            >
              <Typography
                sx={{
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#585874',
                  flex: 1,
                  minWidth: 0,
                  lineHeight: 1.2,
                }}
              >
                {params.data.resource_name}
              </Typography>
            </Tooltip>
          </Box>
        ) : (
          <div style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            paddingRight: "8px"
          }}>
            <Typography
              title={params.data.vendor}
              sx={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                fontSize: '14px',
                fontWeight: 500,
                color: '#585874',
                width: "100%",
                minWidth: 0,
              }}
            >
              {params.data.vendor}
            </Typography>
          </div>
        ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
        padding: 0,
        overflow: "hidden",
      },
    },
    {
      field: "resources_type",
      headerName: "Resource Type",
      filter: true,
      minWidth: 160,
      width: 240,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "account_id",
      headerName: "Account ID",
      filter: true,

      minWidth: 150,
      width: 190,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      sortable: false,

    },
    {
      field: "region_name",
      headerName: "Region",
      filter: true,
      minWidth: 150,
      width: 190,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "last_scanned",
      headerName: "Last Scanned",
      filter: true,
      minWidth: 250,

      cellRenderer: (params: ICellRendererParams) => {
        if (!params.value) return "";
        const date = moment(params.value);
        return (
          <Tooltip
            title={date.format("DD-MMMM-YYYY HH:mm:ss")}
            arrow
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#fff",
                  color: "#000",
                  boxShadow: 1,
                  fontSize: "0.775rem",
                  cursor: "pointer",
                },
              },
              arrow: {
                sx: {
                  color: "#fff",
                },
              },
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              {params.data.total && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    backgroundColor: "#1976d2",
                    color: "white",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  {params.data.total}
                </Box>
              )}
              <Typography
                sx={{
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {date.format("DD-MMMM-YYYY HH:mm:ss")}
              </Typography>
            </Box>
          </Tooltip>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "score",
      headerName: "Security Score",
      filter: true,
      minWidth: 170,
      width: 200,
      cellRenderer: (params: ICellRendererParams) => {
        return params.data?.status === 3 ? (
          <Tooltip
            title={params.data.score}
            arrow
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#fff",
                  color: "#000",
                  boxShadow: 1,
                  fontSize: "0.775rem",
                  cursor: "pointer",
                },
              },
              arrow: {
                sx: {
                  color: "#fff",
                },
              },
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              {params.data.score <= 50 && (
                <img src={red_shield} alt="Low Security Score" />
              )}
              {params.data.score > 50 && params.data.score < 80 && (
                <img src={orange_shield} alt="Medium Security Score" />
              )}
              {params.data.score >= 80 && (
                <img src={green_shield} alt="High Security Score" />
              )}
              <Typography>{Math.round(params.data.score)}</Typography>
            </Box>
          </Tooltip>
        ) : (
          <Box display="flex" alignItems="center" gap={1}>
            <LoopIcon sx={{ color: "text.secondary", fontSize: 16 }} />
            <span>Scanning...</span>
          </Box>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "vulnerability",
      headerName: "Misconfigurations",
      filter: "agNumberColumnFilter",  // ensures numeric filter
      minWidth: 190,
      width: 200,
      valueGetter: (params: any) => {
        // Make sure AG Grid sees this number for filtering and sorting
        return params.data?.status === 3 ? params.data?.failed_count ?? 0 : 0;
      },
      cellRenderer: (params: ICellRendererParams) => {
        return params.data?.status === 3 ? (
          <Tooltip
            title={String(params.data?.failed_count)}
            arrow
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#fff",
                  color: "#000",
                  boxShadow: 1,
                  fontSize: "0.775rem",
                  cursor: "pointer",
                },
              },
              arrow: {
                sx: {
                  color: "#fff",
                },
              },
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              {params.data?.failed_count >= 0 && (
                <img
                  src={misconfig}
                  alt="Misconfigurations"
                  style={{ width: 20, height: 20 }}
                />
              )}
              <Typography>
                {params.data?.failed_count}
              </Typography>
            </Box>
          </Tooltip>
        ) : (
          <>0</>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },



    // {
    //   field: "region_name",
    //   headerName: "Regions",
    //   filter: true,
    //   showNist: false,
    //   minWidth: 180,
    //   width: 180,
    //   tooltipField: "region_name",
    //   cellStyle: {
    //     display: "flex",
    //     alignItems: "center",
    //   },
    // },

  ];

  const decommissionColumnDefs: ColDef[] = [
    {
      field: "selection",
      headerName: "",
      maxWidth: 50,
      checkboxSelection: true,
      headerCheckboxSelection: true,
      pinned: "left",
      sortable: false,
      filter: false,
      resizable: false,
      suppressMovable: true,
      lockPosition: true,
      lockPinned: true,
      // cellClass: "checkbox-cell",
      // headerClass: "checkbox-header",
      suppressSizeToFit: true,
    },
    { field: "number", headerName: "#", filter: true, minWidth: 80, width: 90 },
    {
      field: "device_name",
      headerName: "Name",
      filter: true,
      minWidth: 150,
      cellRenderer: (params: ICellRendererParams) => {
        const criticalityColors: any = {
          critical: "firebrick",
          high: "orange",
          low: "limegreen",
          default: "goldenrod",
        };
        const getLabelText = (id: any) => {
          const option = assetCriticalityOptions.find((o: any) => o.id === id);
          return option?.label || "Unknown";
        };

        return (
          <Box display="flex" alignItems="center" gap={1}>
            <div
              style={{
                width: "4px",
                height: "32px",
                backgroundColor:
                  criticalityColors[params?.data?.criticality?.toLowerCase()] ||
                  "goldenrod",
                borderRadius: "2px",
                marginRight: "8px",
                cursor: "pointer",
              }}
            ></div>
            <Typography
              title={params.data.device_name}
              sx={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                cursor: "pointer",
              }}
            >
              {params.data.device_name}
            </Typography>
          </Box>
        );
      },
    },
    { field: "vendor", headerName: "Vendor", filter: true, minWidth: 150 },
    { field: "model", headerName: "OS", filter: true, minWidth: 140 },
    { field: "device_type", headerName: "Type", filter: true, minWidth: 200 },
    //  { field: "region_name", headerName: "Region", filter: true, minWidth: 150 },
    //  { field: "last_scan_date", headerName: "Total & LastScan", filter: true, minWidth: 150 },
    {
      field: "decommission_on",
      headerName: "Decommissioned On",
      filter: true,
      minWidth: 180,
      cellRenderer: (params: ICellRendererParams) => {
        if (!params.value) return "";
        const date = moment(params.value);
        return date.format("Do MMMM, YYYY");
      },
    },
    {
      field: "security_score",
      headerName: "Status",
      filter: true,
      minWidth: 150,
    },
    {
      field: "decommission_by",
      headerName: "Decommissioned by",
      filter: true,
      minWidth: 180,
      // cellRenderer: (params: ICellRendererParams) => {
      //   if (!params?.data?.decommission_by) return "";
      //   return (
      //       <Typography
      //         title={params.value}
      //         sx={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}
      //       >
      //         {params?.data?.decommission_by}
      //       </Typography>

      //   );
      // },
    },
    //  { field: "vulnerability", headerName: "Misconfigurations", filter: true, minWidth: 150 },
    //  { field : "cve", headerName: "CVEs", filter: true, minWidth: 150 },
    {
      field: "actions",
      headerName: "",
      width: 50,
      filter: false,
      sortable: false,
      cellRenderer: (params: ICellRendererParams) => {
        const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
        const open = Boolean(anchorEl);

        const handleClick = (event: React.MouseEvent<HTMLElement>) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
          setAnchorEl(null);
        };

        const handleAction = (action: string) => {
          switch (action) {
            case "Commission":
              setDeviceIds([params.data.id]);
              setIsCommissionDialogOpen(true);
              console.log("Delete user:", params.data);
              break;
          }
          handleClose();
        };

        return (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <IconButton
              size="small"
              onClick={handleClick}
              sx={{
                color: "text.secondary",
                "&:hover": {
                  backgroundColor: "action.hover",
                },
              }}
            >
              <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              onClick={(e) => e.stopPropagation()}
              PaperProps={{
                sx: {
                  width: 200,
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                },
              }}
            >
              <MenuItem onClick={() => handleAction("Commission")}>
                Commission
              </MenuItem>
            </Menu>
          </Box>
        );
      },
      cellRendererParams: {
        suppressRowClickPropagation: true,
      },
    },
  ];

  const handleScanRowClick = (rowData: any) => {
    console.log(showDecommissioned)
    console.log(rowData);
    if (rowData.last_scan_status == true) {
      console.log("Decommissioned row clicked:", rowData);
      setSelectedAssetSideNav(rowData);
      setAssetDrawerOpen(true);
      console.log("Drawer state after click:", {
        selectedAsset: rowData,
        drawerOpen: true,
      });
      return;
    }
    return;

  };

  const handleRescan = async (device: any) => {
    try {
      const payload = {
        asset_id: [device],
        scan_source: "Assets",
      };
      const response = await axiosInstance.post(END_POINTS.RESCAN, payload);
      if (response.status === 200) {
        updateDeviceInfo(response?.data?.data?.device_list);
        setRescanResponseData(response?.data);
        startTimer();
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  };

  const handleRescanWithCredential = async () => {
    setAnchorElAction(null);
    setIsRescanPopupOpen(true);
    try {
      const response = await axiosInstance.get(END_POINTS.CREDENTIAL_MGMT);
      if (response?.status === 200) {
        setAssetsCredData(response?.data?.data?.cred_list);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
    try {
      const response = await axiosInstance.get(END_POINTS.CREDENTIAL_TYPES);
      if (response?.status === 200) {
        setCredtypes(response?.data?.data);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  };

  const handleMap = async () => {
    setAnchorElAction(null);
    setIsMapCredentialPopupOpen(true);
    try {
      const response = await axiosInstance.get(END_POINTS.CREDENTIAL_MGMT);
      if (response?.status === 200) {
        setAssetsCredData(response?.data?.data?.cred_list);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
    try {
      const response = await axiosInstance.get(END_POINTS.CREDENTIAL_TYPES);
      if (response?.status === 200) {
        setCredtypes(response?.data?.data);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  };

  const handleRescanPopupClose = () => {
    setIsRescanPopupOpen(false);
  };
  const handleMapPopuplose = () => {
    setIsMapCredentialPopupOpen(false);
  };
  const toggleDrawer = (newOpen: boolean) => {
    setOpenSideNav(newOpen);
  };

  const handleCommissionDialogClose = () => {
    setIsCommissionDialogOpen(false);
    formikCommission.resetForm();
  };

  const handleMultipleCommission = () => {
    setDeviceIds(selectedRows.map((device) => device.id));
    setIsCommissionDialogOpen(true);
    setAnchorElAction(null);
  };

  const handleMultipleDecommission = () => {
    setDeviceIds(selectedRows.map((device) => device.id));
    setIsDecommissionDialogOpen(true);
    setAnchorElAction(null);
  };

  const handleDecommissionDialogClose = () => {
    setIsDecommissionDialogOpen(false);
    formik.resetForm();
  };

  const handleDeleteDialogOpen = () => {
    setIsDeleteDialogOpen(true);
    setAnchorElAction(null);
  };

  const handleAssetCriticality = async (criticality: any) => {
    try {
      const payload = {
        asset_id: deviceIds,
        criticality: criticality,
      };
      const response = await axiosInstance.post(
        END_POINTS.ASSETS_CRITICALITY_UPDATE,
        payload
      );
      if (response?.status === 200) {
        setAssetCriticalityData(response?.data?.data?.criticality);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  };

  const getAssetCriticality = async () => {
    try {
      const response = await axiosInstance.get(END_POINTS.ASSETS_CRITICALITY);
      if (response?.status === 200) {
        setAssetCriticalityOptions(response?.data?.data?.dropdown);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  };

  const handleAssetCriticalityDialogOpen = () => {
    getAssetCriticality();
    setDeviceIds(selectedRows.map((device) => device.id));
    setIsAssetCriticalityDialogOpen(true);
    setAnchorElAction(null);
  };

  const handleAssetCriticalityDialogClose = () => {
    setIsAssetCriticalityDialogOpen(false);
  };

  const handleDeleteDialogClose = () => {
    setIsDeleteDialogOpen(false);
    formikDelete.resetForm();
  };

  const fetchAssetsData = async () => {
    try {
      setIsLoading(true);
      const roleReq: any = {
        type: 1
      };
      if (location.state && (location.state as any).id) {
        roleReq.id = (location.state as any).id;
      }
      
      console.log("CLOUD RESOURCES PAGE - Fetching assets data");
      console.log("CLOUD RESOURCES PAGE - location.state received:", location.state);
      console.log("CLOUD RESOURCES PAGE - Final API payload (roleReq) being sent to", url, ":", roleReq);

      const response = await axiosInstance.post(url, roleReq);
      if (response.status === 200) {
        const result = response.data?.data?.cloud_resource || [];
        console.log("result data length", result.length);
        //dataMassage(result);
        const currentAssets = result.filter((item: any) => item.last_scan_status === true);
        dataMassage(currentAssets);
        const previousAssets = result.filter((item: any) => item.last_scan_status === false);
        dataMassage(previousAssets);
        console.log("Current Assets:", currentAssets);
        // Update state
        setAssetsRowData(currentAssets);
        setAssetsPreviousRowData(previousAssets);
        setIsLoading(false);
      }
    } catch (error: any) {
      console.error("Error fetching assets data:", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchDecommsionedAssetsData = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(END_POINTS.DECOMM_DEVICE_LIST);
      if (response.status === 200) {
        const result = response.data?.data?.device_list || [];
        dataMassage(result);
        setAssetsRowData(result);
        setIsLoading(false);
      }
    } catch (error: any) {
      console.error("Error fetching decommissioned assets data:", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const dataMassage = (data: any) => {
    data?.forEach((element: any) => {
      element.security_score_rounded = parseInt(element.security_score)
        ? Math.floor(element.security_score)
        : element.security_score;
      element.vendor = makeFirstLetterCapital(element.vendor);
      const formattedDate = element.last_scan
        ? moment(element.last_scan).format("D, MMMM, YYYY")
        : "";
      element.last_scan_date = formattedDate;
      element.region_name = element.region_name
        ? element.region_name
        : "Unassigned";
      element.failed_count = element.vulnerability_levels?.failed_count ?? null;
      element.region_name = element.region_name
        ? element.region_name
        : "Unassigned";
      element.account_id = element.account_id + ""; // Ensure account_id is a string
    });
    data.sort((a: any, b: any) => {
      const dateA = a.last_scan ? new Date(a.last_scan).getTime() : 0;
      const dateB = b.last_scan ? new Date(b.last_scan).getTime() : 0;
      return dateB - dateA;
    });
    data.forEach((element: any, index: number) => {
      element.number = index + 1;
    });
    console.log("Data after massage:", data);
  };

  const makeFirstLetterCapital = (str: any) => {
    if (str) {
      return str.charAt(0).toUpperCase() + str.substring(1);
    } else {
      return "";
    }
  };
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedRows([]);
    setAssetsRowData([]);
    setIsLoading(true);
    setShowDecommissioned(event.target.checked);
    console.log("Checkbox changed:", event.target.checked);
    if (event.target.checked) {
      setShowDecomAssets(false);
      setAssetsRowData(assetsPreviousRowData);
      setIsLoading(false);
    } else {
      fetchAssetsData();
    }
  };
  const handleExport = () => {
    const dataToExport = selectedRows.length > 0 ? selectedRows : assetsRowData;

    if (!dataToExport || dataToExport.length === 0) {
      toast.error("No data available to export.");
      return;
    }

    try {
      // Prepare the data for export
      const exportData = dataToExport.map((row: any) => {
        const misconfigCount =
          row.status === 3
            ? (row.failed_count ?? row.vulnerability_levels?.failed_count ?? (typeof row.vulnerability === "number" ? row.vulnerability : 0))
            : 0;

        const nistKey = Object.keys(row).find((key) => key.startsWith("NIST_"));
        const rawNist = nistKey ? row[nistKey] : (row.NIST ?? row["NIST_800-53 r5"] ?? 0);
        const nistScore = row.status === 3 ? Math.round(Number(rawNist) || 0) : 0;

        return {
          Number: row.number,
          Name: row.device_name,
          Vendor: row.vendor,
          Model: row.model,
          Type: row.device_type,
          Criticality: row.criticality || "-",
          "Open Ports": Array.isArray(row.discovery_ports) ? row.discovery_ports.length : 0,
          "Security Score": row.security_score ?? 0,
          Misconfigurations: misconfigCount,
          "CVE Score": row.cve_score ?? 0,
          CVEs: row.cve ?? 0,
          NIST: nistScore,
          Regions: row.region_name || "Unassigned",
        };
      });

      // Create a worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // Create a workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Assets");

      // Generate and download the Excel file
      XLSX.writeFile(workbook, "AssetsData.xlsx");

      toast.success("Export to Excel triggered!");
    } catch (error) {
      console.error("Error exporting data:", error);
      toast.error("Failed to export data.");
    }
  };
  // const handleReportExcel = () => {
  //   console.log('Report triggered');
  // };
  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElAction(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorElAction(null);
  };
  const handleSelectionChange = (selectedRows: any) => {
    setSelectedRows(selectedRows);
  };
  const isNotSchedulable = () => {
    return selectedRows.some((item) => item.schedule === "not_schedulable");
  };
  const anySelectedDeviceRequiresRescan = () => {
    return selectedRows.every((device) => device.rescan);
  };
  const unique_devices = useSelector(
    (state: any) => state.UserLoginDetails.unique_devices
  );
  console.log(unique_devices, "unique_devices");
  const handleReport = () => {
    setIsReportDialogOpen(true);
    setType("asset_summary");
  };

  const handleScheduleScan = async () => {
    setDeviceIds(selectedRows.map((device) => device.id));
    setIsAllScheduleable(
      selectedRows.every((item) => item.schedule === "schedulable")
    );
    
    // Reset all state variables to initial values
    setSelectedOption("0");
    setScheduleSelectedOption("new_schedule");
    formikScheduleScan.resetForm();
    
    try {
      const response = await axiosInstance.get(END_POINTS.SCHEDULE_FREQUENCY);
      if (response?.status === 200) {
        setScheduleOptionsFrequency(response?.data?.data?.frequency);
        setScheduleOptionsWeekly(response?.data?.data?.weekly);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
    setAnchorElAction(null);
    // Always start from the first popup
    setIsFirstPopupOpen(true);
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let url = END_POINTS.SCHEDULE_LIST;
    if (timezone) {
      url += `?timezone=${timezone}`;
    }
    try {
      const schedule_response = await axiosInstance.get(url);
      if (schedule_response?.status === 200) {
        setScanSummaryData(schedule_response?.data?.data?.summary_data);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  };

  const handleCancelSchedule = () => {
    setDeviceIds(selectedRows.map((device) => device.id));
    setRemoveAllSchedules(false);
    setIsCancelSchedulePopupOpen(true);
  };

  const handleCancelScheduleClose = () => {
    setIsCancelSchedulePopupOpen(false);
    setRemoveAllSchedules(false); // Reset to default
  };

  const handleRemoveSchedule = async () => {
    const req = {
      device_ids_list: deviceIds,
      remove_all_schedules: removeAllSchedules,
    };

    try {
      const response = await axiosInstance.post(
        "securityscan/cancel-schedule",
        req
      );
      if (response.status === 200) {
        toast.success("Schedule canceled successfully!");
        setIsCancelSchedulePopupOpen(false);
        fetchAssetsData();
      }
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Failed to cancel the schedule."
      );
    }
  };

  const handleDialogClose = () => {
    setIsReportDialogOpen(false);
  };

  const handleReportDrawer = () => {
    setIsReportDrawerOpen(true);
  };

  const getUserTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  };

  const generateFileName = (
    multiple: boolean,
    format: string,
    hostname?: string,
    fileName?: string
  ): string => {
    const now = new Date();
    const dateStr = `${String(now.getMonth() + 1).padStart(2, "0")}${String(
      now.getDate()
    ).padStart(2, "0")}${now.getFullYear()}`;
    const fileExtension = format === "pdf" ? "pdf" : "xlsx";
    return multiple
      ? `${fileName}-${dateStr}.${fileExtension}`
      : `${hostname}-${dateStr}.${fileExtension}`;
  };

  const handleDownload = async (closeDrawer = false) => {
    console.log(`Downloading report in ${reportFormat} format`);
    setDownloadLoading(true);
    const timeZone = getUserTimezone();
    // const payload = {
    //   output_format: reportFormat,
    //   device_uuids: selectedRows.map((device: any) => device.id),
    //   time_zone: timeZone,
    // };
    let asset_ids = [];
    if (type === "asset_report") {
      asset_ids = [selectedAssetSideNav.id]

    } else {
      asset_ids = selectedRows.map((device: any) => device.id);
    }
    const payload = {
      report_format: reportFormat,
      asset_ids: asset_ids,
      time_zone: timeZone,
      type: type,
      module: "cloud",
    };
    try {
      // const response = await axiosInstance.post(
      //   END_POINTS.Asset_SUMMARY_DATA,
      //   payload,
      //   {
      //     responseType: "blob",
      //   }
      // );
      const response = await axiosInstance.post(
        END_POINTS.REPORT_DOWNLOAD,
        payload
      );
      if (response.status === 200) {
        // const fileName = generateFileName(
        //   selectedRows.length > 1,
        //   reportFormat,
        //   selectedRows[0]?.device_name,
        //   "AssetSummaryReport"
        // );
        // const url = window.URL.createObjectURL(new Blob([response.data]));
        // const link = document.createElement("a");
        // link.href = url;
        // link.setAttribute("download", fileName);
        // document.body.appendChild(link);
        // link.click();
        // link.parentNode?.removeChild(link);

        toast.success("Report request submitted, please check Reports section.");
        setDeviceIds([]);
        if (gridApiRef.current && gridApiRef.current.api) {
          gridApiRef.current.api.deselectAll();
        }
        setSelectedRows([]);
        if (closeDrawer) {
          setIsReportDrawerOpen(false);
        }
      } else {
        toast.error("Failed to download the report.");
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    } finally {
      setDownloadLoading(false);
      if (gridApiRef.current && gridApiRef.current.api) {
        gridApiRef.current.api.deselectAll();
      }
      setSelectedRows([])
      setIsReportDialogOpen(false);
    }
  };

  const handleChangeLocation = async () => {
    const response = await axiosInstance.get(
      END_POINTS.GLOBAL_DASHBOARD_REGION
    );
    if (response?.status === 200) {
      setOriginalRegions(response?.data?.data?.regions_list);
      setCurrentRegions(response?.data?.data?.regions_list);
    }
    console.log("Change location triggered");
    setAnchorElAction(null);
    toggleDrawer(true);
  };

  const handleCancel = () => {
    setIsFirstPopupOpen(false);
    setSelectedOption("0");
  };

  const handleNext = () => {
    setIsFirstPopupOpen(false);
    setIsSecondPopupOpen(true);
  };

  const handleSecondPopupClose = () => {
    formikScheduleScan.resetForm();
    setIsSecondPopupOpen(false);
  };

  const handleRescanMulti = () => {
    setDeviceIds(selectedRows.map((device) => device.id));
    handleRescanWithCredential();
  };

  const handleMapMulti = () => {
    setDeviceIds(selectedRows.map((device) => device.id));
    handleMap();
  };

  const headerActions = (
    <Box display="flex" alignItems="center" gap={1}>
      {hasPermissions(ROLES_CONTENT_PROPS.DOWNLOAD_REPORT) && (
        <Button
          onClick={handleReport}
          disabled={selectedRows.length === 0}
          sx={{
            opacity: selectedRows.length === 0 ? 0.5 : 1,
            backgroundColor: isDarkMode
              ? "#1E1E1E !important"
              : "#ffffff !important",
            "&:hover": {
              backgroundColor: "#0F02C3",
              color: "white",
            },
          }}
        >
          <Typography
            variant="body2"
            fontWeight={500}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <img src={isDarkMode ? downloadIcon_dark : downloadIcon} />
            Report
          </Typography>
        </Button>
      )}
      <Button
        variant="outlined"
        onClick={handleMenuOpen}
        color="primary"
        disabled={selectedRows.length === 0}
        sx={{
          opacity: selectedRows.length === 0 ? 0.5 : 1,
          cursor: selectedRows.length === 0 ? "not-allowed" : "pointer",
          backgroundColor: isDarkMode
            ? "#1E1E1E !important"
            : "#ffffff !important",
          "&:hover": {
            backgroundColor: selectedRows.length === 0
              ? (isDarkMode ? "#1E1E1E !important" : "#ffffff !important")
              : "#0F02C3",
            color: selectedRows.length === 0 ? "inherit" : "white",
          },
        }}
      >
        <Typography
          sx={{ display: "flex", alignItems: "center" }}
          variant="body2"
          fontWeight={500}
        >
          Actions{" "}
          <ArrowDropDownIcon sx={{ color: isDarkMode ? "#3F65ED" : "blue" }} />
        </Typography>
      </Button>
      <Menu
        id="cloud-actions-menu"
        anchorEl={anchorElAction}
        open={open}
        onClose={handleClose}
      >
        {!showDecomAssets && selectedRows.length > 0 && (
          <MenuItem onClick={handleMultipleDecommission}>
            Decommission
          </MenuItem>
        )}
        {showDecomAssets && selectedRows.length === 1 && (
          <MenuItem onClick={handleMultipleCommission}>
            Commission
          </MenuItem>
        )}
      </Menu>
      <Typography sx={{ fontWeight: "700", fontSize: "12px" }}>
        Previous Resources
      </Typography>
      <Checkbox checked={showDecommissioned} onChange={handleCheckboxChange} />
      <Typography sx={{ fontWeight: "700", fontSize: "12px" }}>
        Show Decommissioned Assets
      </Typography>
      <Checkbox
        checked={showDecomAssets}
        onChange={(e) => {
          setSelectedRows([]);
          setAssetsRowData([]);
          setIsLoading(true);
          setShowDecomAssets(e.target.checked);
          if (e.target.checked) {
            setShowDecommissioned(false);
            fetchDecommsionedAssetsData();
          } else {
            fetchAssetsData();
          }
        }}
      />
    </Box>
  );

  const handleReset = () => {
    setCurrentRegions(originalRegions);
    setSelectedRegionId(null);
    setExpanded({});
  };

  const handleSave = async () => {
    if (selectedRegionId && selectedRows?.length > 0) {
      const payload = {
        region_id: selectedRegionId,
        device_id: selectedRows.map((device) => device.id),
      };
      try {
        const response = await axiosInstance.post(
          END_POINTS.UPDATE_DEVICE,
          payload
        );
        if (response.status === 200) {
          toast.success(response.data.message);
          setOpenSideNav(false);
          fetchAssetsData();
        }
      } catch (error: any) {
        toast.error(
          error.response.data
            ? error.response.data.message
            : "Something went wrong",
          { type: "error" }
        );
      }
    }
  };

  const RegionTree = ({ nodes, selectedId, setSelectedId }: any) => {
    const toggleExpand = (id: any) => {
      setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    const handleRadioChange = (id: any) => {
      setSelectedId(id);
    };

    const renderTree = (node: any) => (
      <li key={node.id} style={{ marginBottom: 8 }}>
        {/* Expand/Collapse Icon */}
        {node.data?.length > 0 && (
          <span
            onClick={() => toggleExpand(node.id)}
            style={{
              cursor: "pointer",
              marginRight: 8,
              display: "inline-block",
              width: 16,
              textAlign: "center",
            }}
          >
            {expanded[node.id] ? "▼" : "▶"}
          </span>
        )}

        {/* Radio Button and Label */}
        <label
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontSize: "1.2rem",
            fontWeight: "500",
          }}
        >
          <input
            type="radio"
            name="region"
            checked={selectedId === node.id}
            onChange={() => handleRadioChange(node.id)}
            style={{ marginRight: 8, transform: "scale(1.5)" }}
          />
          {node.label}
        </label>

        {/* Render Children */}
        {expanded[node.id] && node.data?.length > 0 && (
          <ul style={{ listStyle: "none", paddingLeft: 20 }}>
            {node.data.map((childNode: any) => renderTree(childNode))}
          </ul>
        )}
      </li>
    );

    return (
      <ul style={{ listStyle: "none", paddingLeft: 0 }}>
        {nodes.map((node: any) => renderTree(node))}
      </ul>
    );
  };

  // const RegionTree = ({ nodes, selectedId, setSelectedId }:any) => {
  //   const [expanded, setExpanded] = useState<Record<string, boolean>>({});

  //   const toggleExpand = (id:any) => {
  //     setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  //   };

  //   return (
  //     <ul style={{ listStyle: 'none', paddingLeft: 20 }}>
  //       {nodes.map((node:any) => (
  //         <li key={node.id}>
  //           {node.data?.length > 0 && (
  //             <span onClick={() => toggleExpand(node.id)} style={{ cursor: 'pointer' }}>
  //               {expanded[node.id] ? '▼' : '▶'}
  //             </span>
  //           )}
  //           <label style={{ marginLeft: 4 }}>
  //             <input
  //               type="radio"
  //               name="region"
  //               checked={selectedId === node.id}
  //               onChange={() => setSelectedId(node.id)}
  //             />
  //             {node.label}
  //           </label>
  //           {expanded[node.id] && node.data && (
  //             <RegionTree nodes={node.data} selectedId={selectedId} setSelectedId={setSelectedId} />
  //           )}
  //         </li>
  //       ))}
  //     </ul>
  //   );
  // };

  // const RegionTree = ({ nodes, selectedId, setSelectedId }: any) => {
  //   const renderTree = (node: any) => (
  //     <li key={node.id}>
  //       <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
  //         <Radio
  //           checked={selectedId === node.id}
  //           onChange={() => setSelectedId(node.id)}
  //           value={node.id}
  //           size="small"
  //         />
  //         {node.label}
  //       </label>
  //       {Array.isArray(node.data) && node.data.length > 0 && (
  //         <ul>
  //           {node.data.map((childNode: any) => renderTree(childNode))}
  //         </ul>
  //       )}
  //     </li>
  //   );

  //   return (
  //     <ul>
  //       {nodes.map((node: any) => renderTree(node))}
  //     </ul>
  //   );
  // };

  const DrawerList = (
    <Box
      sx={{
        width: 400,
        p: 3,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6">Change Location</Typography>
        <Box>
          <Button onClick={handleReset} color="secondary" sx={{ mr: 1 }}>
            Reset
          </Button>
          <Button onClick={handleSave} variant="contained">
            Save
          </Button>
        </Box>
      </Box>

      <TextField
        variant="outlined"
        placeholder="Search..."
        size="small"
        fullWidth
        sx={{ mb: 2 }}
        onChange={(e) => {
          const searchValue = e.target.value.toLowerCase();
          if (searchValue) {
            const filterRegions = (regions: any[]): any[] => {
              return regions
                .map((region) => {
                  if (region.label.toLowerCase().includes(searchValue)) {
                    setExpanded((prev) => ({ ...prev, [region.id]: true }));
                    return region;
                  }
                  if (region.data?.length) {
                    const filteredChildren = filterRegions(region.data);
                    if (filteredChildren.length) {
                      setExpanded((prev) => ({ ...prev, [region.id]: true }));
                      return { ...region, data: filteredChildren };
                    }
                  }
                  return null;
                })
                .filter(Boolean);
            };
            setCurrentRegions(filterRegions(originalRegions));
          } else {
            setCurrentRegions(originalRegions);
            setExpanded({});
          }
        }}
      />

      <Divider sx={{ mb: 2 }} />

      {/* Region Tree */}
      <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
        <RegionTree
          nodes={currentRegions}
          selectedId={selectedRegionId}
          setSelectedId={setSelectedRegionId}
        />
      </Box>
    </Box>
  );

  const formik = useFormik({
    initialValues: {
      password: "",
      reason: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required("Password is required")
        .min(8, "Password must be at least 8 characters")
        .max(20, "Password must not exceed 20 characters")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")
        .matches(
          /[@$!%*?&#]/,
          "Password must contain at least one special character"
        )
        .matches(/^[^\s]+$/, "Password cannot contain spaces"),
      reason: Yup.string()
        .required("Reason is required")
        .min(8, "Reason must be at least 8 characters")
        .max(120, "Reason must not exceed 120 characters")
        .matches(
          /^[^\s][\s\S]*[^\s]$/,
          "Reason cannot start or end with whitespace"
        ),
    }),
    onSubmit: async (values: any) => {
      try {
        const Password_encrypt = {
          password: doEncryptLogin(values.password),
        };
        const passwordValidationResponse = await axiosInstance.post(
          END_POINTS.PASSWORD_CONFIRMATION,
          Password_encrypt
        );
        if (passwordValidationResponse.status === 200) {
          const decommissionResponse = await axiosInstance.post(
            END_POINTS.DECOMMISSION_DEVICES,
            {
              device_id: deviceIds,
              action: "decommission",
            }
          );

          if (decommissionResponse.status === 200) {
            toast.success("Assets decommissioned successfully!");
            setIsDecommissionDialogOpen(false);
            fetchAssetsData();
            formik.resetForm();
          } else {
            toast.error("Failed to decommission devices.");
          }
        } else {
          toast.error("Invalid password.");
        }
      } catch (error: any) {
        toast.error(error.response?.data?.message || "Something went wrong.");
      }
    },
  });

  const formikCommission = useFormik({
    initialValues: {
      password: "",
      reason: "",
      rescanImmediately: true,
    },
    validationSchema: Yup.object({
      password: Yup.string().required("Password is required"),
      reason: Yup.string()
        .required("Reason is required")
        .min(8, "Reason must be at least 8 characters")
        .max(120, "Reason must not exceed 120 characters")
        .matches(
          /^[^\s][\s\S]*[^\s]$/,
          "Reason cannot start or end with whitespace"
        ),
    }),
    onSubmit: async (values: any) => {
      try {
        const Password_encrypt = {
          password: doEncryptLogin(values.password),
        };
        const passwordValidationResponse = await axiosInstance.post(
          END_POINTS.PASSWORD_CONFIRMATION,
          Password_encrypt
        );
        if (passwordValidationResponse.status === 200) {
          if (values.rescanImmediately && deviceIds.length === 1) {
            // Trigger immediate live single-resource rescan
            const rescanResponse = await axiosInstance.post(
              END_POINTS.RESCAN_RECOMMISSION,
              {
                device_id: deviceIds[0],
                scan_type: "aws_discovery_posture",
                rescan_type: "cloud_single_resource",
              }
            );

            if (rescanResponse.status === 200) {
              toast.success("Resource recommissioned and live cloud rescan initiated!");
              setIsCommissionDialogOpen(false);
              setShowDecomAssets(false);
              setShowDecommissioned(false);
              fetchAssetsData();
              formikCommission.resetForm();
            } else {
              toast.error("Failed to initiate cloud rescan.");
            }
          } else {
            // Standard recommission (marks active without immediate live rescan)
            const commissionResponse = await axiosInstance.post(
              END_POINTS.DECOMMISSION_DEVICES,
              {
                device_id: deviceIds,
                action: "recommission",
              }
            );

            if (commissionResponse.status === 200) {
              toast.success("Assets commissioned successfully!");
              setIsCommissionDialogOpen(false);
              setShowDecomAssets(false);
              setShowDecommissioned(false);
              fetchAssetsData();
              formikCommission.resetForm();
            } else {
              toast.error("Failed to commission devices.");
            }
          }
        } else {
          toast.error("Invalid password.");
        }
      } catch (error: any) {
        toast.error(error.response?.data?.message || "Something went wrong.");
      }
    },
  });

  const formikDelete = useFormik({
    initialValues: {
      password: "",
      reason: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required("Password is required")
        .min(8, "Password must be at least 8 characters")
        .max(20, "Password must not exceed 20 characters"),
      reason: Yup.string()
        .required("Reason is required")
        .min(8, "Reason must be at least 8 characters")
        .max(120, "Reason must not exceed 120 characters"),
    }),
    onSubmit: async (values: any) => {
      try {
        const Password_encrypt = {
          password: doEncryptLogin(values.password),
        };
        const passwordValidationResponse = await axiosInstance.post(
          END_POINTS.PASSWORD_CONFIRMATION,
          Password_encrypt
        );
        if (passwordValidationResponse.status === 200) {
          const payload = {
            device_id: selectedRows.map((device) => device.id),
            comment: values.reason,
          };
          const deleteResponse = await axiosInstance.post(
            END_POINTS.DELETE_DEVICES,
            payload
          );
          if (deleteResponse.status === 200) {
            toast.success("Assets deleted successfully!");
            setIsDeleteDialogOpen(false);
            fetchAssetsData();
            formikDelete.resetForm();
          }
        } else {
          toast.error("Failed to delete assets.");
        }
      } catch (error: any) {
        toast.error(error.response?.data?.message || "Something went wrong.");
      }
    },
  });

  const formikScheduleScan = useFormik({
    initialValues: {
      scanName: "",
      frequency: "",
      onDate: "",
      atTime: "",
      day: "",
      frequencyId: "",
      search: "",
    },
    validationSchema: Yup.object({
      scanName: Yup.string().required("Scan Name is required"),
      frequency: Yup.string().required("Frequency is required"),
      onDate: Yup.string().when("frequency", (frequency, schema) => {
        return !["Daily", "Hourly", "Weekly"].includes(String(frequency || ""))
          ? schema.required("Date is required")
          : schema.notRequired();
      }),
      day: Yup.string().when("frequency", (frequency, schema) => {
        return String(frequency) === "Weekly"
          ? schema.required("Day is required")
          : schema.notRequired();
      }),
      atTime: Yup.string().required("Time is required"),
    }),
    onSubmit: async (values) => {
      console.log("Form submitted:", values);

      const convertToUTC = (time: string, date: string) => {
        if (time) {
          let utcDate;
          if (date) {
            const [day, month, year] = date.split("-").map(Number);
            const [hours, minutes] = time
              .split(/[: ]/)
              .map((value, index) =>
                index === 0 && time.includes("PM") && value !== "12"
                  ? +value + 12
                  : value === "12" && time.includes("AM")
                    ? 0
                    : +value
              );
            const localDate = new Date(year, month - 1, day, hours, minutes);
            utcDate = new Date(
              localDate.getUTCFullYear(),
              localDate.getUTCMonth(),
              localDate.getUTCDate(),
              localDate.getUTCHours(),
              localDate.getUTCMinutes(),
              localDate.getUTCSeconds()
            );
          } else {
            const now = new Date();
            const [hours, minutes] = time
              .split(/[: ]/)
              .map((value, index) =>
                index === 0 && time.includes("PM") && value !== "12"
                  ? +value + 12
                  : value === "12" && time.includes("AM")
                    ? 0
                    : +value
              );
            const localDate = new Date(
              now.getFullYear(),
              now.getMonth(),
              now.getDate(),
              hours,
              minutes
            );
            utcDate = new Date(
              localDate.getUTCFullYear(),
              localDate.getUTCMonth(),
              localDate.getUTCDate(),
              localDate.getUTCHours(),
              localDate.getUTCMinutes(),
              localDate.getUTCSeconds()
            );
          }
          const utcHours = String(utcDate.getHours()).padStart(2, "0");
          const utcMinutes = String(utcDate.getMinutes()).padStart(2, "0");
          const formattedTime = `${utcHours}:${utcMinutes}`;

          return formattedTime;
        }
      };

      const payload: any = {
        scan_name: values.scanName,
        frequency_id: values?.frequencyId,
        time: convertToUTC(
          values.atTime,
          values.onDate ? values.onDate.split("-").reverse().join("-") : ""
        ),
        device_ids: deviceIds,
        date: values.onDate ? values.onDate.split("-").reverse().join("-") : "",
      };
      if (values.frequency === "Weekly") {
        payload.day = values.day;
      }
      if (selectedOption && !isallScheduleable) {
        payload.remove_option = selectedOption;
      }
      try {
        const response = await axiosInstance.post(
          END_POINTS.MY_SCAN_SCHEDULED_SCAN,
          payload
        );
        if (response?.status === 200) {
          toast.success(response.data.message);
          setIsSecondPopupOpen(false);
          setSelectedOption("0");
          formikScheduleScan.resetForm();
          fetchAssetsData();
        }
      } catch (error: any) {
        toast.error(
          error.response.data
            ? error.response.data.message
            : "Something went wrong",
          { type: "error" }
        );
      }
    },
  });

  const updateRescan = async () => {
    const deviceId = rescanResponseData?.data?.device_list[0].id;
    if (deviceId && !latestRescanDevicesList.includes(deviceId)) {
      latestRescanDevicesList.push(deviceId);
    }
    const checkEligibleRescanDevices = assetsRowData?.filter(
      (item: any) => item.status < 3
    );
    checkEligibleRescanDevices?.forEach((item: any) => {
      if (item.id && !latestRescanDevicesList.includes(item.id)) {
        latestRescanDevicesList.push(item.id);
      }
    });
    // this.deviceService.rescanDeviceOrder(this.latestRescanDevicesList, this.rescanCallbackOrder);
    const payload = {
      device_uuids: latestRescanDevicesList,
    };
    const response = await axiosInstance.post(
      END_POINTS.DEVICE_MANAGEMENT_RESCAN,
      payload
    );
    if (response.status === 200) {
      rescanCallbackOrder(response?.data);
    } else {
      toast.error("Failed to rescan devices.");
    }
  };

  const rescanCallbackOrder = (response: any) => {
    toast.success(response.message, { type: "success" });
    const rescanResponseData = response;
    setRescanResponseData(rescanResponseData);
    if (rescanResponseData.data.device_list[0]) {
      updateDeviceInfo(response?.data?.device_list);
      isEligibleForTimer();
    }
  };

  const startTimer = () => {
    if (!intervalRequest.current) {
      intervalRequest.current = setInterval(() => {
        updateRescan();
      }, 25000);
    }
  };

  const isEligibleForTimer = () => {
    const dt = assetsRowData.filter((item: any) => item.status < 3);
    if (dt.length === 0) {
      if (intervalRequest.current) {
        clearInterval(intervalRequest.current);
        intervalRequest.current = null;
        setLatestRescanDevicesList([]);
      }
    } else {
      startTimer();
    }
  };

  const updateDeviceInfo = (response: any) => {
    if (response && response?.length) {
      let data: any[] = assetsRowData?.length ? assetsRowData : [];
      if (data.length) {
        response.forEach((item: any) => {
          const findIndex = data.findIndex((itemObj: any) => {
            return itemObj.id === item.id;
          });
          data[findIndex] = item;
        });
        dataMassage(data);
        setAssetsRowData([...data]);
        startTimer();
      }
    }
  };

  const selectedFrequency = formikScheduleScan.values.frequency;
  const rescanWithCredential = (response: any) => {
    console.log("Re-scan with credential triggered", response);
    setSelectedRows([]);
    updateDeviceInfo(response);
  };

  const mapCallback = (response: any) => {
    console.log("Re-scan with credential triggered", response);
    setSelectedRows([]);
    fetchAssetsData();
    // updateDeviceInfo(response);
  };

  const previousResources = {
    headerName: "Status",
    headerTooltip: "Status",
    field: 'status',
    cellRenderer: (params: any) => (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          background: '#F4F5FA',
          border: '1.5px solid #C3C6D4',
          borderRadius: '8px',
          padding: '2px 12px 2px 8px',
          fontWeight: 500,
          fontSize: '15px',
          color: '#585874',
          width: 'fit-content',
          height: '32px',
          gap: 1,
        }}
      >
        <Box
          sx={{
            width: 12,
            height: 12,
            borderRadius: '50%',
            background: '#585874',
            marginRight: '8px',
            display: 'inline-block',
          }}
        />
        Inactive
      </Box>
    ),
    cellStyle: {
      display: "flex",
      alignItems: "center",
    },
    sortable: true,
    filter: true,
    minWidth: 120,
  };

  // Add Last Scanned column for previousResources
  const previousResourcesColumns = [
    previousResources,
    {
      headerName: "Last Scanned",
      field: "last_scanned",
      minWidth: 130,
      valueGetter: (params: any) => params.data?.last_scanned,
      cellRenderer: (params: any) => {
        if (!params.value) return "-";
        return moment(params.value).format("DD MMM YYYY");
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      sortable: false,
      filter: false,
    },
  ];

  useEffect(() => {
    fetchAssetsData();
    const handleFilterSaved = (response: any) => {
      console.log("Filter saved event received:", response);
      setSelectedRows([]);
      setAssetsRowData([]);
      setIsLoading(true);
      fetchAssetsData();
    };
    eventEmitter.on("filterSaved", handleFilterSaved);
    return () => {
      eventEmitter.off("filterSaved", handleFilterSaved);
    };
  }, [location.state?.id]);
  useEffect(() => {
    const assetsDetails = assetsRowData.map((data: any) => ({
      device_name: data.device_name,
      device_id: data.id,
    }));
    dispatch(
      authActions.login({
        assetsData: assetsDetails,
      })
    );
    console.log(assetsRowData);
  }, [assetsRowData, dispatch]);
  return (
    <Card
      variant="outlined"
      sx={{ height: "calc(100vh - 120px)", borderRadius: 3 }}
    >
      <AgGridTable
        columnDefs={
          showDecomAssets
            ? decommissionColumnDefs
            : showDecommissioned
            ? [...assetsColumnDefs, ...previousResourcesColumns]
            : [...assetsColumnDefs, ...nistColumns]
        }
        data={assetsRowData}
        height={"calc(100vh - 160px)"}
        showSearch
        headerActions={headerActions}
        onRowClick={showDecommissioned || showDecomAssets ? undefined : handleScanRowClick}
        isLoading={isLoading}
        isRowSelectable={true}
        rowSelection="multiple"
        onSelectionChange={handleSelectionChange}
        gridOptions={gridOptions}
        styles={agGridInlineStyles}
        gridRef={gridApiRef}
      />
      <Dialog
        open={isDecommissionDialogOpen}
        onClose={handleDecommissionDialogClose}
      >
        <DialogTitle>Are you sure you want to decommission?</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Please enter your password to decommission the asset(s).
          </Typography>
          <form onSubmit={formik.handleSubmit}>
            <TextField
              fullWidth
              type="password"
              label="Password"
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={
                formik.touched.password &&
                  typeof formik.errors.password === "string"
                  ? formik.errors.password
                  : undefined
              }
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              multiline
              rows={4}
              label="Reason"
              name="reason"
              value={formik.values.reason}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.reason && Boolean(formik.errors.reason)}
              helperText={
                formik.touched.reason &&
                  typeof formik.errors.reason === "string"
                  ? formik.errors.reason
                  : undefined
              }
              sx={{ mb: 2 }}
            />
            <DialogActions>
              <Button
                onClick={handleDecommissionDialogClose}
                variant="outlined"
                color="secondary"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="error"
                disabled={!formik.isValid || formik.isSubmitting}
                sx={{
                  opacity: formik.isValid ? 1 : 0.5,
                  "&:hover": {
                    backgroundColor: "error.main",
                  },
                }}
              >
                Decommission
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        open={isCommissionDialogOpen}
        onClose={handleCommissionDialogClose}
      >
        <DialogTitle>Are you sure you want to commission?</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Please
          </Typography>
          <form onSubmit={formikCommission.handleSubmit}>
            <TextField
              fullWidth
              type="password"
              label="Password"
              name="password"
              value={formikCommission.values.password}
              onChange={formikCommission.handleChange}
              onBlur={formikCommission.handleBlur}
              error={
                formikCommission.touched.password &&
                Boolean(formikCommission.errors.password)
              }
              helperText={
                formikCommission.touched.password &&
                  typeof formikCommission.errors.password === "string"
                  ? formikCommission.errors.password
                  : undefined
              }
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              multiline
              rows={4}
              label="Reason"
              name="reason"
              value={formikCommission.values.reason}
              onChange={formikCommission.handleChange}
              onBlur={formikCommission.handleBlur}
              error={
                formikCommission.touched.reason &&
                Boolean(formikCommission.errors.reason)
              }
              helperText={
                formikCommission.touched.reason &&
                  typeof formikCommission.errors.reason === "string"
                  ? formikCommission.errors.reason
                  : undefined
              }
              sx={{ mb: 2 }}
            />
            {deviceIds.length === 1 && (
              <Box sx={{ mb: 2, display: "flex", alignItems: "center" }}>
                <Checkbox
                  id="rescanImmediately"
                  name="rescanImmediately"
                  checked={formikCommission.values.rescanImmediately}
                  onChange={(e) =>
                    formikCommission.setFieldValue(
                      "rescanImmediately",
                      e.target.checked
                    )
                  }
                  color="primary"
                />
                <Typography variant="body2" sx={{ cursor: "pointer" }} onClick={() => formikCommission.setFieldValue("rescanImmediately", !formikCommission.values.rescanImmediately)}>
                  Trigger immediate live cloud rescan for this resource
                </Typography>
              </Box>
            )}
            <DialogActions>
              <Button
                onClick={handleCommissionDialogClose}
                variant="outlined"
                color="secondary"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={
                  !formikCommission.isValid || formikCommission.isSubmitting
                }
                sx={{
                  opacity: formikCommission.isValid ? 1 : 0.5,
                  "&:hover": {
                    backgroundColor: "primary.main",
                  },
                }}
              >
                Commission
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
      <Dialog open={isDeleteDialogOpen} onClose={handleDeleteDialogClose}>
        <DialogTitle>Are you sure you want to delete asset(s)?</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {unique_devices
              ? "Please note that even if you delete this asset, it will be considered in the limit of unique assets."
              : "Please enter your password to delete the asset(s)."}
          </Typography>
          <form onSubmit={formikDelete.handleSubmit}>
            <TextField
              fullWidth
              type="password"
              label="Password"
              name="password"
              value={formikDelete.values.password}
              onChange={formikDelete.handleChange}
              onBlur={formikDelete.handleBlur}
              error={
                formikDelete.touched.password &&
                Boolean(formikDelete.errors.password)
              }
              helperText={
                formikDelete.touched.password &&
                  typeof formikDelete.errors.password === "string"
                  ? formikDelete.errors.password
                  : undefined
              }
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              multiline
              rows={4}
              label="Reason"
              name="reason"
              value={formikDelete.values.reason}
              onChange={formikDelete.handleChange}
              onBlur={formikDelete.handleBlur}
              error={
                formikDelete.touched.reason &&
                Boolean(formikDelete.errors.reason)
              }
              helperText={
                formikDelete.touched.reason &&
                  typeof formikDelete.errors.reason === "string"
                  ? formikDelete.errors.reason
                  : undefined
              }
              sx={{ mb: 2 }}
            />
            <Typography variant="caption" sx={{ mb: 2, display: "block" }}>
              Maximum 120 characters required
            </Typography>
            <DialogActions>
              <Button
                onClick={handleDeleteDialogClose}
                variant="outlined"
                color="secondary"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="error"
                disabled={!formikDelete.isValid || formikDelete.isSubmitting}
                sx={{
                  opacity: formikDelete.isValid ? 1 : 0.5,
                }}
              >
                Delete
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
      <Drawer
        anchor={"right"}
        open={openSidenav}
        onClose={() => toggleDrawer(false)}
      >
        {DrawerList}
      </Drawer>
      <Dialog open={isFirstPopupOpen} onClose={handleCancel}>
        <DialogTitle>Scan Schedule</DialogTitle>
        <DialogContent>
          <RadioGroup
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
          >
            <FormControlLabel
              value="0"
              control={<Radio />}
              label="Remove from all the existing schedule"
            />
            <FormControlLabel
              value="1"
              control={<Radio />}
              label="Remove from all of my schedule"
            />
            <FormControlLabel
              value="2"
              control={<Radio />}
              label="Add without removing from other schedule"
            />
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} variant="outlined" color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleNext}
            variant="contained"
            color="primary"
            disabled={!selectedOption} // Disable Next button if no option is selected
          >
            Next
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isSecondPopupOpen} onClose={handleSecondPopupClose}>
        <DialogTitle>Scan Schedule</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            You are scheduling this asset which will remove from all the
            schedules. Select an option to schedule a scan to continue.
          </Typography>
          <RadioGroup
            value={selectedscheduleOption}
            onChange={(e) => {
              setScheduleSelectedOption(e.target.value);
              formikScheduleScan.resetForm();
            }}
            row
            sx={{ mb: 2 }}
          >
            <FormControlLabel
              value="new_schedule"
              control={<Radio />}
              label="New Schedule"
            />
            <FormControlLabel
              value="existing_scan"
              control={<Radio />}
              label="Add to an existing scan"
            />
          </RadioGroup>
          {selectedscheduleOption === "new_schedule" && (
            <form onSubmit={formikScheduleScan.handleSubmit}>
              <TextField
                fullWidth
                label="Scan Name"
                name="scanName"
                variant="outlined"
                sx={{ mb: 2 }}
                value={formikScheduleScan.values.scanName}
                onChange={formikScheduleScan.handleChange}
                onBlur={formikScheduleScan.handleBlur}
                error={
                  formikScheduleScan.touched.scanName &&
                  Boolean(formikScheduleScan.errors.scanName)
                }
                helperText={
                  formikScheduleScan.touched.scanName &&
                  formikScheduleScan.errors.scanName
                }
              />

              <TextField
                fullWidth
                select
                label="Frequency"
                name="frequency"
                variant="outlined"
                sx={{ mb: 2 }}
                value={selectedFrequency}
                onChange={(e) => {
                  const selectedOption: any = scheduleOptionsFrequency.find(
                    (option: any) => option.name === e.target.value
                  );
                  formikScheduleScan.handleChange(e);
                  formikScheduleScan.setFieldValue(
                    "frequencyId",
                    selectedOption?.id || ""
                  );
                  formikScheduleScan.setFieldValue("day", "");
                  formikScheduleScan.setFieldValue("onDate", "");
                  formikScheduleScan.setTouched({
                    ...formikScheduleScan.touched,
                    onDate: false,
                  });
                }}
                onBlur={formikScheduleScan.handleBlur}
                error={
                  formikScheduleScan.touched.frequency &&
                  Boolean(formikScheduleScan.errors.frequency)
                }
                helperText={
                  formikScheduleScan.touched.frequency &&
                  formikScheduleScan.errors.frequency
                }
              >
                {scheduleOptionsFrequency.map((option: any) => (
                  <MenuItem key={option.id} value={option.name}>
                    {typeof option.name === "string" ||
                      typeof option.name === "number"
                      ? option.name
                      : JSON.stringify(option.name)}
                  </MenuItem>
                ))}
              </TextField>

              {selectedFrequency !== "Daily" &&
                selectedFrequency !== "Hourly" &&
                selectedFrequency !== "Weekly" && (
                  <TextField
                    fullWidth
                    label="On Date"
                    type="date"
                    name="onDate"
                    variant="outlined"
                    slotProps={{ inputLabel: { shrink: true } }}
                    sx={{ mb: 2 }}
                    value={formikScheduleScan.values.onDate}
                    onChange={formikScheduleScan.handleChange}
                    onBlur={formikScheduleScan.handleBlur}
                    error={
                      formikScheduleScan.touched.onDate &&
                      Boolean(formikScheduleScan.errors.onDate)
                    }
                    helperText={
                      formikScheduleScan.touched.onDate &&
                      formikScheduleScan.errors.onDate
                    }
                  />
                )}

              {selectedFrequency === "Weekly" && (
                <TextField
                  fullWidth
                  select
                  label="Day"
                  name="day"
                  variant="outlined"
                  sx={{ mb: 2 }}
                  value={formikScheduleScan.values.day}
                  onChange={formikScheduleScan.handleChange}
                  onBlur={formikScheduleScan.handleBlur}
                  error={
                    formikScheduleScan.touched.day &&
                    Boolean(formikScheduleScan.errors.day)
                  }
                  helperText={
                    formikScheduleScan.touched.day &&
                    formikScheduleScan.errors.day
                  }
                >
                  {scheduleOptionsWeekly.map((option: any) => (
                    <MenuItem key={option.id} value={option.name}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              )}

              <TextField
                fullWidth
                select
                label="At Time"
                name="atTime"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                sx={{ mb: 2 }}
                value={formikScheduleScan.values.atTime}
                onChange={formikScheduleScan.handleChange}
                onBlur={formikScheduleScan.handleBlur}
                error={
                  formikScheduleScan.touched.atTime &&
                  Boolean(formikScheduleScan.errors.atTime)
                }
                helperText={
                  formikScheduleScan.touched.atTime &&
                  formikScheduleScan.errors.atTime
                }
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                      },
                    },
                  },
                  native: false,
                  renderValue: (value) =>
                    typeof value === "string" ? value : "Enter Time",
                }}
              >
                {Array.from({ length: 1440 }, (_, i) => {
                  const hours = Math.floor(i / 60);
                  const minutes = i % 60;
                  const time = `${String(hours % 12 || 12).padStart(
                    2,
                    "0"
                  )}:${String(minutes).padStart(2, "0")} ${hours < 12 ? "AM" : "PM"
                    }`;
                  return (
                    <MenuItem key={time} value={time}>
                      {time}
                    </MenuItem>
                  );
                })}
              </TextField>
            </form>
          )}
          {selectedscheduleOption === "existing_scan" && (
            <>
              <TextField
                fullWidth
                placeholder="Search"
                variant="outlined"
                value={formikScheduleScan.values.search || ""}
                onChange={(e) => {
                  formikScheduleScan.setFieldValue("search", e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <Button
                      onClick={() =>
                        formikScheduleScan.setFieldValue("search", "")
                      }
                      size="small"
                      sx={{ minWidth: "auto" }}
                    >
                      X
                    </Button>
                  ),
                }}
                sx={{ mb: 2 }}
              />
              <Box
                sx={{
                  maxHeight: 200,
                  overflowY: "auto",
                  overflowX: "hidden",
                  border: "1px solid #ddd",
                  borderRadius: 1,
                  p: 1,
                }}
              >
                {scanSummaryData.length === 0 ? (
                  <Typography
                    variant="body2"
                    align="center"
                    color="text.secondary"
                  >
                    No data found
                  </Typography>
                ) : (
                  scanSummaryData.map((item: any, index: number) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 1,
                        p: 1,
                        borderRadius: 1,
                        backgroundColor: "#f9f9f9",
                        "&:hover": {
                          backgroundColor: "#e0f7fa",
                        },
                      }}
                      title={`${item.scanName} - ${item.frequency}`}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          flex: 1,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          color:
                            formikScheduleScan.values.search &&
                              item.scanName
                                .toLowerCase()
                                .includes(
                                  formikScheduleScan.values.search.toLowerCase()
                                )
                              ? "blue"
                              : "inherit",
                        }}
                      >
                        {item.scanName}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: 1,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "right",
                          color:
                            formikScheduleScan.values.search &&
                              item.frequency
                                .toLowerCase()
                                .includes(
                                  formikScheduleScan.values.search.toLowerCase()
                                )
                              ? "blue"
                              : "inherit",
                        }}
                      >
                        {item.frequency}
                      </Typography>
                    </Box>
                  ))
                )}
              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions>
          {!isallScheduleable && (
            <Button
              onClick={() => {
                setIsSecondPopupOpen(false);
                setIsFirstPopupOpen(true);
                setSelectedOption("0");
                setScheduleSelectedOption("new_schedule");
                formikScheduleScan.resetForm();
              }}
              variant="outlined"
              color="secondary"
            >
              Back
            </Button>
          )}
          <Button
            onClick={handleSecondPopupClose}
            variant="outlined"
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              formikScheduleScan.handleSubmit();
              setIsSecondPopupOpen(false);
            }}
            variant="contained"
            color="primary"
            disabled={
              !formikScheduleScan.isValid || formikScheduleScan.isSubmitting
            }
          >
            Schedule
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={isCancelSchedulePopupOpen}
        onClose={handleCancelScheduleClose}
      >
        <DialogTitle>Cancel Schedule</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Select an option to cancel the schedule scan.
          </Typography>
          <RadioGroup
            value={removeAllSchedules ? "remove_all" : "remove_my"}
            onChange={(e) =>
              setRemoveAllSchedules(e.target.value === "remove_all")
            }
          >
            <FormControlLabel
              value="remove_my"
              control={<Radio />}
              label="Remove from my schedule"
              sx={{
                "& .MuiTypography-root": {
                  color: !removeAllSchedules ? "blue" : "inherit",
                },
              }}
            />
            <FormControlLabel
              value="remove_all"
              control={<Radio />}
              label="Remove from all schedule"
              sx={{
                "& .MuiTypography-root": {
                  color: removeAllSchedules ? "blue" : "inherit",
                },
              }}
            />
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancelScheduleClose}
            variant="outlined"
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={handleRemoveSchedule}
            variant="contained"
            color="primary"
          >
            Remove
          </Button>
        </DialogActions>
      </Dialog>
      <RescanWithCredentialPopup
        open={isRescanPopupOpen}
        onClose={handleRescanPopupClose}
        assetsCredData={assetsCredData}
        credData={credTypes}
        deviceId={deviceIds}
        rescanCallback={rescanWithCredential}
      />
      <MapCredentialPopup
        open={isMapCredentialPopupOpen}
        onClose={handleMapPopuplose}
        assetsCredData={assetsCredData}
        credData={credTypes}
        deviceId={deviceIds}
        mapCallback={mapCallback}
      />
      <AssetDetailsDrawer
        isMenu={false}
        open={assetDrawerOpen}
        onClose={() => {
          console.log("Closing drawer");
          setAssetDrawerOpen(false);
        }}
        assetData={selectedAssetSideNav}
        isCloud={true}
        isCve={false}
        onReport={() => {
          console.log("Opening report drawer for cloud asset");
          setAssetDrawerOpen(false); // Close the AssetDetailsDrawer first
          setType("asset_report");
          setIsReportDrawerOpen(true); // Then open the report drawer
        }}
      />
      <Dialog
        open={isAssetCriticalityDialogOpen}
        onClose={handleAssetCriticalityDialogClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
          Set Asset Criticality
        </DialogTitle>
        <DialogContent>
          <Typography align="center" sx={{ mb: 2, color: "gray" }}>
            Select an option to set the criticality for the <b>asset_name</b>.
          </Typography>
          <FormControl fullWidth>
            <InputLabel>Select Criticality</InputLabel>
            <Select
              value={selectedCriticalId}
              label="Select Criticality"
              onChange={(e) => setSelectAssetsCriticaledId(e.target.value)}
            >
              {assetCriticalityOptions.map((option: any) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            variant="outlined"
            onClick={handleAssetCriticalityDialogClose}
          >
            Cancel
          </Button>
          <Button
            disabled={selectedCriticalId === ""}
            variant="contained"
            onClick={handleAssetCriticality}
          >
            Set
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isReportDialogOpen}
        onClose={handleDialogClose}
        sx={{
          "& .MuiDialog-paper": {
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "360px",
            height: "300px",
            borderRadius: "4px",
            transform: "translate(-50%, -50%)",
            padding: "10px",
            boxSizing: "border-box",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px",
            color: theme.palette.mode === "dark" ? "#ffffff" : "#101828",
          }}
        >
          Download Resource Summary Report?
        </DialogTitle>
        <DialogContent
          sx={{
            textAlign: "center",
            fontWeight: 400,
            fontSize: "14px",
            color: theme.palette.mode === "dark" ? "#b0b0b0" : "#667085",
            overflow: "visible",
            maxHeight: "none",
          }}
        >
          <Typography variant="body2" sx={{ mb: 2, color: theme.palette.mode === "dark" ? "#b0b0b0" : "#666666" }}>
            This report offers a summary of essential information for {selectedRows.length} Resource's.
          </Typography>
          <Typography
            variant="body2"
            fontWeight={500}
            align="center"
            sx={{ mb: 2, fontWeight: "bold" }}
          >
            Report Format
          </Typography>
          <RadioGroup
            value={reportFormat}
            onChange={(e) => setReportFormat(e.target.value)}
            row
            sx={{ justifyContent: "center" }}
          >
            <FormControlLabel value="pdf" control={<Radio />} label="Pdf" />
            <FormControlLabel value="excel" control={<Radio />} label="Excel" />
          </RadioGroup>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            paddingBottom: "24px",
          }}
        >
          <Button
            onClick={handleDialogClose}
            variant="outlined"
            sx={{ width: 130 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDownload}
            variant="contained"
            color="primary"
            disabled={downloadLoading}
            sx={{ width: 130 }}
          >
            {downloadLoading ? (
              <Box display="flex" alignItems="center" gap={1}>
                <CircularProgress size={10} sx={{ color: 'white' }} />
                <Typography sx={{ color: 'white', fontSize: '11px' }}>
                  Downloading...
                </Typography>
              </Box>
            ) : (
              "Download"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Report Drawer - Same UI as AssetComplianceReportDrawer */}
      <Drawer
        anchor="right"
        open={isReportDrawerOpen}
        onClose={() => setIsReportDrawerOpen(false)}
      >
        <Box sx={{ pl: 3, width: 400, overflowY: 'hidden' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" fontWeight={700}>Resource Report</Typography>
            <IconButton onClick={() => setIsReportDrawerOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>


          <Box
            sx={{
              mb: 2,
              height: {
                xs: '60vh',
                sm: '65vh',
                md: '70vh',
                lg: '75vh',
                xl: '80vh',
              },
              overflowY: 'auto',
            }}
            className="scroll"
          >
            <Typography fontWeight={600}>Report Format</Typography>
            <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
              <FormControlLabel
                control={
                  <Radio
                    checked={reportFormat === 'pdf'}
                    onChange={() => setReportFormat('pdf')}
                    size="small"
                  />
                }
                label="Pdf"
                sx={{
                  width: '120px',
                  '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
                }}
              />
              <FormControlLabel
                control={
                  <Radio
                    checked={reportFormat === 'excel'}
                    onChange={() => setReportFormat('excel')}
                    size="small"
                  />
                }
                label="Excel"
                sx={{
                  width: '120px',
                  '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
                }}
              />
            </Box>

            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 3 }}
              disabled={downloadLoading}
              onClick={() => handleDownload(true)}
            >
              {downloadLoading ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <CircularProgress size={10} sx={{ color: 'white' }} />
                  <Typography sx={{ color: 'white', fontSize: '11px' }}>
                    Downloading Report...
                  </Typography>
                </Box>
              ) : (
                "Download Report"
              )}
            </Button>
          </Box>
        </Box>
      </Drawer>
    </Card>
  );
};

export default CloudAssetDetails;
